// src/components/NotFoundPage.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const NotFoundPage = () => {
  return (
    <Container sx={{ textAlign: 'center', marginTop: '100px' }}>
      <Typography variant="h4" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1">
        Oops! The page you're looking for doesn't exist.
      </Typography>
    </Container>
  );
};

export default NotFoundPage;
